module.exports = __webpack_public_path__ + "static/fonts/jura-cyrillic.4ebc3a3.woff2";